import React, { FC } from 'react'
import { StyledContent } from './styles'
import { Content } from '../../../components/content/Content'
import PublicLayout from '../../publicLayout/containers/PublicLayout'

const faqPage: FC = () => {
	return (
		<PublicLayout>
			<StyledContent>
				<Content slug={'faq'} />
			</StyledContent>
		</PublicLayout>
	)
}

export default faqPage
